import { Navigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "./CustomerAuthContext";
import { useLang } from "@/i18n/LanguageContext";

/**
 * Gate /account routes. Redirects to /account/auth (locale-aware) when the
 * visitor is not signed in. Keeps the original target so the auth page can
 * redirect back after login.
 */
export function RequireCustomer({ children }: { children: React.ReactNode }) {
  const { user, loading } = useCustomerAuth();
  const { localePath } = useLang();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen bg-background" aria-hidden="true" />;
  }
  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`${localePath("/account/auth")}?next=${next}`} replace />;
  }
  return <>{children}</>;
}